'use strict';

function InventoryManagementGridDirective() {
  return {
    restrict: 'E',
    template: require('../templates/inventory-management-grid.html'),
    controller: 'InventoryManagementGridController',
    scope: {
      selectedFlights: '<',
      reoptPreviewData: '='
    },
    link: function link(scope) {
      scope.$watch('selectedFlights', scope.onSelectFlights);
      scope.$on('collapsable-panel-trigger', scope.onPanel);
    }
  };
}
InventoryManagementGridDirective.$inject = [];
module.exports = InventoryManagementGridDirective;